// src/onboarding/OnbClouds.jsx
// Phase 37 — extracted from src/App.jsx (Plan 37-03).

import { useMemo } from 'react';

export default function OnbClouds({ density = 2, top = 40 }) {
  const clouds = useMemo(() => Array.from({ length: density }).map((_, i) => ({
    key: i,
    t: top + i * 22,
    dur: 40 + i * 12,
    delay: -i * 10,
    scale: 0.6 + (i % 2) * 0.25,
    opacity: 0.55 - i * 0.1,
    left: (i * 37) % 80,
  })), [density, top]);
  return (
    <>
      {clouds.map(c => (
        <div key={c.key} className="onb-cloud" style={{
          top: c.t,
          left: `${c.left}%`,
          transform: `scale(${c.scale})`,
          opacity: c.opacity,
          "--drift-dur": `${c.dur}s`,
          "--drift-delay": `${c.delay}s`,
        }}/>
      ))}
    </>
  );
}
